import { createAction, props } from '@ngrx/store';
import { ServerMessage } from '../../models/server-message';
import { Invoice } from '../../models/invoice';
import { CreditCard } from '../../models/credit-card';

export const paymentStart = createAction(
    '[Payment] Open Payment Dialog'
);

export const paymentLoad = createAction(
    '[Payment] Load Invoices and Cards'
);

export const paymentInvoiceLoadSucceeded = createAction(
    '[Payment] Load Invoices Succeeded',
    props<{ invoices: Invoice[] }>()
);

export const paymentCardLoadSucceeded = createAction(
    '[Payment] Load Cards Succeeded',
    props<{ creditCards: CreditCard[] }>()
);

export const paymentLoadFailed = createAction(
    '[Payment] Load Failed',
    props<{ message: ServerMessage }>()
);

export const paymentToggleInvoice = createAction(
    '[Payment] Toggle Invoice',
    props<{ invoiceId: string }>()
);

export const paymentSelectCreditCard = createAction(
    '[Payment] Select Credit Card',
    props<{ cardId: string }>()
);

export const paymentSelectNewCard = createAction(
    '[Payment] Select New Credit Card'
);

export const paymentUpdateNewCard = createAction(
    '[Payment] Update New Card Data',
    props<{ number: string, expiryMonth: number, expiryYear: number, cardholder: string }>()
);

export const paymentRemoveCard = createAction(
    '[Payment] Remove Credit Card',
    props<{ cardId: string }>()
);

export const paymentSubmit = createAction(
    '[Payment] Submit Payment'
);

export const paymentResultSuccess = createAction(
    '[Payment] Successful Response'
);

export const paymentResultError = createAction(
    '[Payment] Submit Failed',
    props<{ message: ServerMessage }>()
);
